import { Component, computed, inject } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { AudioService } from './core/services/audio';
import { ScreenNavigationService } from './core/services/screen-navigation';
import { TopAppBar } from './shared/components/top-app-bar/top-app-bar';
import { SCREEN_COMPONENTS } from './screen-registry';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgComponentOutlet, TopAppBar],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly screenNavigation = inject(ScreenNavigationService);
  // Injetado aqui para instanciar o serviço (singleton) assim que o app sobe,
  // garantindo que a música de fundo comece a tocar desde a home.
  private readonly audio = inject(AudioService);

  /** Componente da tela atual, ou null se não houver entrada registrada (fallback: router-outlet / home). */
  protected readonly currentScreenComponent = computed(() => SCREEN_COMPONENTS[this.screenNavigation.screen()] ?? null);
}
